// extracted by mini-css-extract-plugin
export default {"menuBlock":"JG-z","title":"KG-z","nav":"LG-z","flexCell":"MG-z","facetLink":"NG-z"};